import { isBezorgbaarEmail } from './email/bezorgbaar.js';

/** Server-produced registration. Preparing this never sends a message. */
export interface PartnerConcept {
  actieId: string; messageId: string; conversationId: string; bronHash: string; inputHash: string;
  offerteId: string; leadId: string; leadNummer: string; doorverwijzingId: string;
  partnerId: string; partnerNaam: string; segment: string; ccEmail: string; klantEmail: string;
  /** Existing referral: preserve its first send/SLA timestamp. */
  vervolg?: { bronHash: string; verstuurdAt: string };
}
export function leesPartnerConcept(value: unknown): PartnerConcept | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const p = value as Record<string, unknown>;
  const keys = ['actieId','messageId','conversationId','bronHash','inputHash','offerteId','leadId','leadNummer',
    'doorverwijzingId','partnerId','partnerNaam','segment','ccEmail','klantEmail'] as const;
  if (keys.some(k => typeof p[k] !== 'string' || !p[k] || String(p[k]).length > 240)) return null;
  if (!/^[a-f0-9]{64}$/.test(String(p.bronHash)) || !/^[a-f0-9]{64}$/.test(String(p.inputHash)) ||
    !/^L-\d+$/.test(String(p.leadNummer)) || !isBezorgbaarEmail(String(p.ccEmail)) || !isBezorgbaarEmail(String(p.klantEmail)) ||
    String(p.ccEmail).toLowerCase() === String(p.klantEmail).toLowerCase()) return null;
  const result = Object.fromEntries(keys.map(k => [k, p[k]])) as unknown as PartnerConcept;
  if (p.vervolg !== undefined) {
    const v = p.vervolg as PartnerConcept['vervolg'];
    if (!v || typeof v !== 'object' || !/^[a-f0-9]{64}$/.test(v.bronHash) || typeof v.verstuurdAt !== 'string'
      || !Number.isFinite(Date.parse(v.verstuurdAt))) return null;
    result.vervolg = {bronHash:v.bronHash,verstuurdAt:v.verstuurdAt};
  }
  return result;
}
export function partnerConceptenUitActies(acties: unknown): PartnerConcept[] {
  if (!Array.isArray(acties)) return [];
  return acties.flatMap(a => {
    if (a?.verb !== 'bereid_partnerdoorverwijzing' || a.uitkomst?.besluit !== 'akkoord' || a.uitkomst.ok !== true) return [];
    const p = leesPartnerConcept(a.uitkomst.partnerconcept);
    return p ? [p] : [];
  });
}

/** Preparing/forwarding an additional question does not supply the specialist's answer. */
export function wachtOpPartnerAntwoord(actie: {verb:string;uitkomst?:{besluit:string;ok?:boolean;partnerconcept?:unknown}}): boolean {
  return actie.verb==='bereid_partnerdoorverwijzing' && actie.uitkomst?.besluit==='akkoord'
    && actie.uitkomst.ok===true && !!leesPartnerConcept(actie.uitkomst.partnerconcept)?.vervolg;
}
